
import { defineComponent, ref, onMounted } from "vue";
import _ from "lodash";
import { useI18n } from "vue-i18n";
import { ApiBase } from "@/core/api";
import { TaggingItem } from "@/core/directive/interface/common";

interface Filter {
  platform_id: string | number;
  payment_order_no: string;
  ocps_customer_id: string;
  status: string;
  paid_time_start: string;
  paid_time_end: string;
}

export default defineComponent({
  name: "payment-dropdown",
  components: {},
  emits: ["submit-filter", "reset-filter"],
  setup(props, { emit }) {
    const formRef = ref<null | HTMLFormElement>(null);
    const formData = ref<Filter>({
      platform_id: "",
      payment_order_no: "",
      ocps_customer_id: "",
      status: "",
      paid_time_start: "",
      paid_time_end: "",
    });

    const customer = ref<TaggingItem>({
      label: "",
      value: "",
    });

    const { t } = useI18n();

    const options = ref({
      platform: [] as TaggingItem[],
      customer: [] as TaggingItem[],
      customerLoading: false,
      status: [
        {
          label: t("payment.pending"),
          value: "pending",
        },
        {
          label: t("payment.paid"),
          value: "paid",
        },
        {
          label: t("payment.canceled"),
          value: "canceled",
        },
      ] as TaggingItem[],
    });

    const getTaggingData = async () => {
      const { data } = await ApiBase.getTaggingData({
        short_key: ["payment_platform"],
      });
      if (data.code == 0) {
        options.value.platform = data.data.payment_platform.items;
      }
    };

    const getCustomerOptions = async (query: string) => {
      options.value.customerLoading = true;
      const { data } = await ApiBase.getCustomerSourceData({ name: query });
      options.value.customerLoading = false;
      if (data.code == 0) {
        options.value.customer = data.data;
      }
    };

    const debounceCustomerSearch = _.debounce(getCustomerOptions, 1000);

    const searchCustomerItems = (query: string) => {
      debounceCustomerSearch(query);
    };

    const customerChange = (e) => {
      formData.value.ocps_customer_id = e.value;
    };

    const customerClear = () => {
      formData.value.ocps_customer_id = "";
    };

    const submit = () => {
      emit("submit-filter", formData.value);
    };

    const handleReset = () => {
      formRef.value?.resetFields();
      emit("reset-filter");
    };

    onMounted(() => {
      getTaggingData();
    });

    return {
      formData,
      formRef,
      customer,
      options,
      t,
      submit,
      handleReset,
      searchCustomerItems,
      customerChange,
      customerClear,
    };
  },
});
